import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_AdviserSearchResultsList.scss'
import AdviserProfileSummary from './AdviserProfileSummary'
import MobileAdviserProfileSummary from './MobileAdviserProfileSummary'
import DropDownList from '../../common/forms/DropDownList'
import { Row, Col } from 'react-bootstrap'
import Pager from '../../common/Pager'
import Spinner from '../../common/Spinners/Spinner/Spinner'
import PropTypes from 'prop-types';

class AdviserSearchResultsList extends React.Component {
  static propTypes = {
    profiles: PropTypes.array.isRequired,
    totalMatchingProfiles: PropTypes.number.isRequired,
    contactAdviser: PropTypes.func.isRequired,
    viewProfile: PropTypes.func.isRequired,
    loadNextPage: PropTypes.func.isRequired,
    hasMorePages: PropTypes.bool.isRequired,
    pageSize: PropTypes.number.isRequired,
    userLocation: PropTypes.string,
    sortProfiles: PropTypes.func.isRequired,
    sortOptions: PropTypes.array.isRequired,
    currentPage: PropTypes.number.isRequired,
    fetchAllPages: PropTypes.func.isRequired,
    fetchPage: PropTypes.func.isRequired,
    isDetailedSearch: PropTypes.bool.isRequired,
    currentSort: PropTypes.string.isRequired
  };

  constructor (props) {
    super(props)
    this.renderAdviserSummary = this.renderAdviserSummary.bind(this)
    this.renderMobileAdviserSummary = this.renderMobileAdviserSummary.bind(
      this
    )
    this.compareProfileByName = this.compareProfileByName.bind(this)
    this.state = {
      profileCurrentlyLoading: 0
    }
    this.filterDropDown = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.profiles !== this.props.profiles) {
      const profilesLoading = this.props.profiles.reduce(
        (count, profile) => count + (profile.loading ? 1 : 0),
        0
      );
      this.setState({ profileCurrentlyLoading: profilesLoading });
    }
  }

  pageRange (currentPage, pageSize, allProfiles) {
    if (currentPage === 1) {
      return Math.min(pageSize, allProfiles)
    }
    const startOfRange = (currentPage - 1) * pageSize + 1
    const endOfRange = Math.min(currentPage * pageSize, allProfiles)
    return `${startOfRange} - ${endOfRange}`
  }

  compareProfileByName (profileA, profileB) {
    if (profileA.adviserName > profileB.adviserName) return 1
    if (profileA.adviserName < profileB.adviserName) return -1

    return 0
  }

  render () {
    const {
      totalMatchingProfiles,
      currentPage,
      sortOptions,
      sortProfiles,
      profiles,
      loadNextPage,
      pageSize,
      isDetailedSearch,
      currentSort
    } = this.props
    const { profileCurrentlyLoading } = this.state
    const resultsShown = this.pageRange(
      currentPage,
      pageSize,
      totalMatchingProfiles
    )
    return (
      <div>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12}>
            <Row>
              <Col xs={12} sm={7} md={7} lg={7}>
                <h3 className={styles['matches-found']}>
                  {totalMatchingProfiles +
                    (totalMatchingProfiles > 1 || totalMatchingProfiles === 0
                      ? ' Matches were'
                      : ' Match was') +
                    ' found'}
                </h3>
              </Col>
              {isDetailedSearch && <Col
                sm={5}
                md={5}
                lg={5}
                className={`d-none d-md-block ${styles['no-padding-right']}`} >
                <DropDownList
                  label='Sort by'
                  listData={sortOptions}
                  value={currentSort}
                  handleChange={sortProfiles}
                  ref={this.filterDropDown}
                  className={styles['filter-dropdown']}
                />
              </Col>}
              {isDetailedSearch && <Col xs={12} className={`${styles['padding-top-mobile']} d-block d-md-none`}>
                <DropDownList
                  label=''
                  listData={sortOptions}
                  value={currentSort}
                  handleChange={sortProfiles}
                  ref={this.filterDropDown}
                  className={styles['filter-dropdown']}
                />
              </Col>}
            </Row>
            <Row>
              <Col
                className={`d-none d-md-block ${styles['no-padding-left']}`}
                sm={6}
                md={6}
                lg={6}
              >
                <span>
                  <h6>
                    Showing {resultsShown} of {totalMatchingProfiles}
                  </h6>
                </span>
              </Col>
              <Col xs={12} className={'d-block d-md-none'}>
                <span>
                  Showing {resultsShown} of {totalMatchingProfiles}
                </span>
              </Col>
              <Col
                className={`d-none d-md-block ${styles['no-padding-right']}`}
                sm={6}
                md={6}
                lg={6}
              >
                <Pager
                  currentPage={this.props.currentPage}
                  totalPages={Math.ceil(
                    totalMatchingProfiles / this.props.pageSize
                  )}
                  loadNextPage={loadNextPage}
                  loadPage={this.props.fetchPage}
                />
              </Col>
              <Col
                className={`${styles['no-padding-left']} d-block d-md-none`}
                xs={12}
              >
                <Pager
                  currentPage={this.props.currentPage}
                  totalPages={Math.ceil(
                    totalMatchingProfiles / this.props.pageSize
                  )}
                  loadNextPage={loadNextPage}
                  loadPage={this.props.fetchPage}
                />
              </Col>
            </Row>
          </Col>
          <Col className="d-none d-md-block" sm={12} md={12} lg={12}>
            {this.renderProfileSummaries(
              profiles,
              this.renderAdviserSummary,
              profileCurrentlyLoading > 0,
              isDetailedSearch
            )}
          </Col>
          <Col xs={12} className={`${styles['padding-top-mobile']} d-block d-md-none`}>
            {this.renderProfileSummaries(
              profiles,
              this.renderMobileAdviserSummary,
              profileCurrentlyLoading > 0,
              isDetailedSearch
            )}
          </Col>
        </Row>
        <Row>
          <Col
            className={`d-none d-md-block ${styles['no-padding-right']}`}
            sm={12}
            md={12}
            lg={12}
          >
            {profileCurrentlyLoading === 0 &&
              <Pager
                currentPage={this.props.currentPage}
                totalPages={Math.ceil(
                  totalMatchingProfiles / this.props.pageSize
                )}
                loadNextPage={loadNextPage}
                loadPage={this.props.fetchPage}
              />}
          </Col>
          <Col
            className={`${styles['no-padding-left']} d-block d-md-none`}
            xs={12}
          >
            {profileCurrentlyLoading === 0 &&
              <Pager
                currentPage={this.props.currentPage}
                totalPages={Math.ceil(
                  totalMatchingProfiles / this.props.pageSize
                )}
                loadNextPage={loadNextPage}
                loadPage={this.props.fetchPage}
              />}
          </Col>
        </Row>
      </div>
    )
  }

  renderProfileSummaries (profiles, render, profilesAreLoading, isDetailedSearch) {
    if (profilesAreLoading) {
      return <Spinner />
    }
    if (!isDetailedSearch) {
      const sortedProfiles = [...profiles].sort(this.compareProfileByName)
      return sortedProfiles.map(render)
    }

    return profiles.map(render)
  }

  renderAdviserSummary (profile, index) {
    return (
      <AdviserProfileSummary
        key={`${index}-${profile.adviserId}`}
        adviser={profile}
        loading={profile.loading}
        contactAdviser={this.props.contactAdviser}
        viewProfile={this.props.viewProfile}
        investorLocation={this.props.userLocation}
      />
    )
  }

  renderMobileAdviserSummary (profile, index) {
    return (
      <MobileAdviserProfileSummary
        key={`${index}-${profile.adviserId}`}
        adviser={profile}
        loading={profile.loading}
        contactAdviser={this.props.contactAdviser}
        viewProfile={this.props.viewProfile}
        investorLocation={this.props.userLocation}
      />
    )
  }
}

export default  (AdviserSearchResultsList)
